const getUser = () => {
	const data = JSON.parse(localStorage.getItem('profile')) || {}
	data.icon = Number(data.icon)
	return data || {}
}

export default getUser